import {GetFaqUrlParams} from 'domain/usecases';
import {
	makeGetFaqUrl,
	// makeMockedFaqUrl as makeGetFaqUrl,
} from 'main/factories/usecases/private/external-links/remote-help';

const getFaqUrl = async ({signal}: GetFaqUrlParams) => makeGetFaqUrl().get({signal});

export {getFaqUrl};
